import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allOrders } from 'app/mocks/data/operations/orders'

import { api } from 'app/utils/constants'

import { Order } from 'app/types/operations/order'

export const getOrder = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.operations.orders.DETAILS}`,
    ({ params }) => {
        const { id } = params

        const orderFound = allOrders.find((order) => order.id.toString() === id)

        // Not found
        if (!orderFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<Order>(orderFound)
    },
)
